var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('confirm-box',{ref:"error",attrs:{"noConfirm":true}}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm me-1",class:_vm.btnClass,attrs:{"type":"button"},on:{"click":_vm.toggle}},[_c('i',{staticClass:"fa-solid fa-ban"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }